import React from 'react';
import { Autocomplete } from 'formik-material-ui-lab';
import TextField from '@material-ui/core/TextField';
import { Field } from 'formik';

const AutocompleteField = (props: any) => {
  const {
    field: { name },
    form: { errors, submitCount },
  } = props;
  //const name = props.name;
  const errorMessage = errors && errors[name];
  const enableError = !!submitCount && !props.disabled && errorMessage;

  return (
    <Autocomplete
      {...props}
      options={props.options || []}
      getOptionLabel={(option: any) => option}
      renderInput={(params: any) => {
        return (
          <TextField
            {...params}
            label={props.label}
            variant="outlined"
            error={enableError}
            helperText={enableError ? errorMessage : ''}
          />
        );
      }}
    />
  );
};

export default (props: any) => <Field {...props} component={AutocompleteField} />;
